
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TRetatilerdataState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
        rerender1:boolean
    }
    
    
    const initialRetatilerdataState: TRetatilerdataState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 1,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:"",
        rerender1: false,
        
    }
    
    export const retatilerDataSlice = createSlice({
        name: 'retatilerData',
        initialState:initialRetatilerdataState,
        reducers: {
            setRetatilerdata: (state:TRetatilerdataState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:TRetatilerdataState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setCurrentPage: (state:TRetatilerdataState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TRetatilerdataState, {payload}: PayloadAction<number>) => { 
            state.totalPage = payload; 
        },
            setSearchTerm: (state:TRetatilerdataState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TRetatilerdataState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TRetatilerdataState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TRetatilerdataState, {payload}: PayloadAction<boolean>) => { 
              state.loading = payload
            },
            setRerender: (
                state: TRetatilerdataState,
                { payload }: PayloadAction<boolean>
              ) => {
                state.rerender1 = payload;
              },
        },
    })
    
    
    export const { setRerender,setRetatilerdata, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading } = retatilerDataSlice.actions
    export default retatilerDataSlice.reducer
    